import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import OfficerFormModalAction from "@common/redux/actions/OfficerFormModalAction";
import { officerSchema } from "../helpers/validation-schemas/officerSchema";
import { useEffect } from "react";
import { isAlphaNumeric, isNumeric } from "../helpers/forms";
import { useSelector } from "react-redux";

const useOfficerFormModal = ({ officerFormData, searchQuery }) => {
  const { officerType } = useSelector((store) =>
    OfficerFormModalAction.getStatePath(store),
  );
  const methods = useForm({
    resolver: yupResolver(officerSchema(officerType)),
    defaultValues: officerFormData,
    mode: "all",
  });

  const {
    reset,
    formState: { isValid, errors },
  } = methods;

  // Effect to prefill form values when user input searchQuery changes
  useEffect(() => {
    if (isAlphaNumeric(searchQuery) || isNumeric(searchQuery)) {
      reset({ badgeNumber: searchQuery });
    } else reset({ name: searchQuery });
  }, [searchQuery, reset]);

  const closeModal = () => {
    reset();
    OfficerFormModalAction.reset().then(OfficerFormModalAction.onClose);
  };

  const onSubmit = (data) => {
    if (!isValid) {
      console.error(errors);
      return;
    }
    OfficerFormModalAction.onSubmit(data);
    reset();
    OfficerFormModalAction.reset();
  };

  return { methods, closeModal, onSubmit };
};

export default useOfficerFormModal;
